import { ProtectedStateError } from './api';

export async function loadProtectedState<T>(
  load: () => Promise<T>,
  clear: () => void,
): Promise<T> {
  try {
    return await load();
  } catch (error) {
    if (error instanceof ProtectedStateError) clear();
    throw error;
  }
}
